import actions from "../../constants/actions";

const initialState = {
    data: [],
    isLoading: false,
    errorMessage: "",
};

export default function faq(state = initialState, action) {
    switch (action.type) {
        case actions.FAQ.LOAD:
            return { ...state, isLoading: true };
        case actions.FAQ.LOAD_SUCCESS:
            return {
                ...state,
                data: action.payload.data,
                isLoading: false,
                errorMessage: "",
            };
        case actions.FAQ.LOAD_FAIL:
            return {
                ...state,
                isLoading: false,
                errorMessage: action.payload,
            };
        default:
            return state;
    }
}
